export default __webpack_public_path__ + "static/media/payments.bd80c869.svg";